import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import * as companyApi from "../../api/companyApi/companyApi";

import {yupResolver} from "@hookform/resolvers/yup";
import CompanyForm from "./CompanyForm";
import {EQCompany, initializeCompany} from "../../models/serverModels/EQCompany";

const CreateCompany = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQCompany>,
    Params.Create<EQCompany>
  >({
    api: companyApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Company`);
        queryClient.invalidateQueries("CompanyList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQCompany>({
    defaultValues: initializeCompany(),
  });

  const onSubmit: SubmitHandler<EQCompany> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeCompany(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="설비관리 업체 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <CompanyForm />
          <ConfirmButtonGroup link={`/Company`} cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateCompany;
